// import { STYLE_OPTIONS } from 'src/constants';
import tabEditStyle from 'src/components/View/AccountView/tabEdit.style';
import modalDialogFormStyle from 'src/components/View/ModalDialogForm/modalDialogForm.style';

const importPBTemplatesModalStyle = (theme) => ({
  ...tabEditStyle(theme),
  ...modalDialogFormStyle(theme),

  container: {
    width: '100%',
    maxWidth: '100%',
    minHeight: 400,
    overflow: 'hidden',
  },

  headerSection: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(0, 1),
  },

  templateFoundText: {
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    fontWeight: 500,
    marginBottom: theme.spacing(0.5),
  },

  selectedText: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },

  selectAllHeaderCheckbox: {
    padding: theme.spacing(0.5),
  },

  tableContainer: {
    width: '100%',
    border: 'none',
    boxShadow: 'none',
    '& .MuiTable-root': {
      tableLayout: 'fixed',
      width: '100%',
    },
  },

  headerCell: {
    backgroundColor: theme.palette.grey[50],
    fontWeight: 700,
    fontSize: '0.8125rem',
    color: theme.palette.text.primary,
    padding: theme.spacing(1.5, 1),
    borderBottom: `2px solid ${theme.palette.divider}`,
  },

  selectHeaderCell: {
    width: '60px',
    minWidth: '60px',
    maxWidth: '60px',
    textAlign: 'center',
  },

  nameHeaderCell: {
    width: '35%',
    minWidth: '120px',
  },

  previewHeaderCell: {
    width: 'auto',
    minWidth: '200px',
  },

  templateRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-selected': {
      backgroundColor: `${theme.palette.primary.main}08`,
      '&:hover': {
        backgroundColor: `${theme.palette.primary.main}12`,
      },
    },
  },

  selectCell: {
    width: '60px',
    minWidth: '60px',
    maxWidth: '60px',
    padding: theme.spacing(0.5, 1),
    textAlign: 'center',
  },

  nameCell: {
    width: '35%',
    minWidth: '120px',
    padding: theme.spacing(1),
    verticalAlign: 'top',
  },

  previewCell: {
    width: 'auto',
    minWidth: '200px',
    padding: theme.spacing(1),
    verticalAlign: 'top',
  },

  rowCheckbox: {
    padding: theme.spacing(0.25),
  },

  templateName: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: theme.palette.text.primary,
    lineHeight: 1.3,
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },

  templatePreview: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.4,
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },

  noTemplatesText: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: '1rem',
    fontStyle: 'italic',
  },

  // Custom tooltip styles for rich content
  customTooltip: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[8],
    fontSize: '0.875rem',
    maxWidth: 400,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
  },

  tooltipContent: {
    '& img': {
      maxWidth: '100%',
      height: 'auto',
      marginTop: theme.spacing(1),
      borderRadius: theme.shape.borderRadius,
    },
  },
  [theme.breakpoints.down('md')]: {
    container: {
      minHeight: 300,
    },

    headerSection: {
      padding: theme.spacing(0, 0.5),
    },

    headerCell: {
      padding: theme.spacing(1, 0.5),
      fontSize: '0.75rem',
    },

    selectCell: {
      padding: theme.spacing(0.25, 0.5),
    },

    nameCell: {
      padding: theme.spacing(0.75, 0.5),
      minWidth: '100px',
    },

    previewCell: {
      padding: theme.spacing(0.75, 0.5),
      minWidth: '150px',
    },

    templateName: {
      fontSize: '0.8125rem',
      '-webkit-line-clamp': 3,
    },

    templatePreview: {
      fontSize: '0.75rem',
      '-webkit-line-clamp': 4,
    },
  },

  [theme.breakpoints.down('sm')]: {
    selectHeaderCell: {
      width: '50px',
      minWidth: '50px',
      maxWidth: '50px',
      textAlign: 'center',
    },

    nameHeaderCell: {
      width: '40%',
      minWidth: '90px',
    },

    selectCell: {
      width: '50px',
      minWidth: '50px',
      maxWidth: '50px',
    },

    nameCell: {
      width: '40%',
      minWidth: '90px',
    },
  },
});

export default importPBTemplatesModalStyle;
